import { uneteToke } from './mock/uneteData.js';


angular.module('Toke').factory('uneteRepository', function ($q) {

    function getUnete() {
        return $q.resolve(uneteToke)
    }

    // para lista futura
    // function getUneteFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Unete')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getUnete: getUnete
    };

});

